import { useState } from 'react';
import { cn } from '@client/lib/utils';
import { adminLogin } from '@client/lib/api';

interface AdminLoginProps {
  onSuccess: () => void;
}

export function AdminLogin({ onSuccess }: AdminLoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await adminLogin(password);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">🔐</div>
          <h1 className="text-[34px] leading-[41px] font-bold">Admin Access</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            className={cn(
              'w-full px-4 py-3 bg-secondary rounded-xl',
              'text-[17px] leading-[22px]',
              'placeholder:text-muted-foreground',
              'focus:outline-none focus:ring-2 focus:ring-primary'
            )}
            autoFocus
          />

          {error && (
            <p className="text-destructive text-[13px] leading-[18px] text-center">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className={cn(
              'w-full py-3 bg-primary text-primary-foreground rounded-xl',
              'text-[17px] leading-[22px] font-semibold disabled:opacity-50 ios-pressable'
            )}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
